/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {provisionDigitalWalletToken} from '../api'

export const useMutationProvisionDigitalWalletToken = createReactQueryMutationHook('provisionDigitalWalletToken', provisionDigitalWalletToken)
